import React, { useEffect, useRef, useState } from "react";
import Header from "../../Components/Header";
import Sidebar from "../../Components/Sidebar";
import { AP_Payout_Rms } from "../../Configuration/API_URL";
import axios from "axios";
import { toast } from "react-toastify";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { useForm, useFieldArray } from "react-hook-form";
import RoundLoader from "../../Components/Common/RoundRingLoader";
import Loader from "../../Components/Common/Loader";
import {
  AESEncryption,
  ApiResDecrypt,
  formatDate,
  getClientsRawData,
  onlyNumber,
  onlyNumberUpTo100,
} from "../../CommonMethhods/CommonMethods";
import SingleSignOnSideBar from "../../Components/SingleSignOnSideBar";

function RmsPayout() {
  const storeToken = localStorage.getItem("ssoToken");
  const [rmsTableData, setRmsTableData] = useState([]);
  const [downloadBtnLoader, setDownloadBtn] = useState(false);
  const [insertBtnLoader, setInsertloadBtn] = useState(false);
  const [loader, setLoader] = useState(false);
  const [debitError, setDebitError] = useState(false);
  const [rmsFields, setRmsField] = useState([]);
  const typeRef = useRef("brokerage");
  const [rejectBtnLoader, setRejectloadBtn] = useState(false);

  // const handleTypeDropType = (e) => {
  //   setRmsTableData([]);
  //   typeRef.current.value = e.target.value;
  //   if (typeRef.current.value !== "") {
  //     setLoader(true);
  //     getRMSDetailList("grid", e.target.value);
  //   }
  // };

  useEffect(() => {
    setRmsTableData([]);
    // typeRef.current.value = e.target.value;
    if (typeRef.current.value !== "") {
      setLoader(true);
      getRMSDetailList("grid", "brokerage");
    }
  }, []);
  // get rms detail
  const getRMSDetailList = async (typeView = "grid", product, apcode) => {
    let payloadValue = {
      fileType: typeView,
      productType: product,
      apcode: apcode || "",
    };
    let encPayload = AESEncryption(payloadValue);
    try {
      const getRmsList = await axios.post(
        AP_Payout_Rms.RmsDataList_URL,
        `"${encPayload}"`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${storeToken}`,
            reserv: 1,
          },
        }
      );
      // const res = dataMain.data;
      const response = ApiResDecrypt(getRmsList?.data);

      let res1, res;
      if (typeView === "excel") {
        res1 = response.data;
      } else if (typeView === "grid") {
        res = response.data.rmsBrokerages;
      }

      if (res || res1) {
        if (typeView === "grid") {
          setRmsTableData(res);
        } else if (typeView === "excel") {
          window.open(res1, "_self", "noopener,noreferrer");
          toast.success("Excel download successfully");
        }
      } else {
        toast.error("Data not exist");
      }
    } catch (error) {
      toast.error("Something went wrong, Please try again later.");
    } finally {
      setDownloadBtn(false);
      setLoader(false);
    }
  };

  // useEffect(() => {
  //   if (typeRef.current.value !== "") {
  //     getRMSDetailList("grid", "brokerage");
  //   }
  // }, []);
  //end rm detail

  // update rms table
  const insertRMSDetail = async (new_users) => {
    let payloadValue = { rms: new_users };
    let encPayload = AESEncryption(payloadValue);
    try {
      const getRmsList = await axios.post(
        AP_Payout_Rms.RmsInsertUpdate_URL,

        `"${encPayload}"`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${storeToken}`,
            reserv: 1,
          },
        }
      );
      const res = ApiResDecrypt(getRmsList?.data);

      if (res?.status === 0) {
        getRMSDetailList("grid", typeRef.current.value);
        setRmsField([]);
        toast.success(res?.data);
      } else {
        toast.error(res?.message);
      }
    } catch (error) {
      toast.error("Something went wrong, Please try again later.");
    } finally {
      setInsertloadBtn(false);
      setRejectloadBtn(false);
    }
  };

  //end update

  const RmsSchema = Yup.object().shape({
    RmsKey: Yup.array().of(
      Yup.object().shape({
        apId: Yup.string().notRequired(),
        apCode: Yup.string().notRequired(),
        apName: Yup.string().notRequired(),
        sapCode: Yup.string().required(),
        periodFrom: Yup.string().required(),
        periodTo: Yup.string().required(),
        module: Yup.string().notRequired(),
        pan: Yup.string().required(),
        gstNo: Yup.string().required(),
        actualGrossBrokerage: Yup.string().required(),
        grossBrokerage: Yup.string().required(),
        apSharing: Yup.string().required(),
        netBrokerage: Yup.string().required(),
        gst18Perc: Yup.string().required(),
        totalInvoice: Yup.string().required(),
        tds5Perc: Yup.string().required(),
        apLedger: Yup.string().required(),
        apRisk: Yup.string().required(),
        airtelCharges: Yup.string().required(),
        depositToBeAdjusted: Yup.string().required(),
        depositAmt: Yup.string().required(),
        apAMC: Yup.string().required(),
        otherDeductionFR: Yup.string().required(),
        otherDeductionFin: Yup.string().required(),
        finalPayout: Yup.string().required(),
        nseRegistered: Yup.string().required(),
        bseRegistered: Yup.string().required(),
        franchiseeStatus: Yup.string().required(),
        rmsStatus: Yup.string().required(),

        // payoutAmt: Yup.string().notRequired(),
        // lessTDS: Yup.string().notRequired(),
        // paymentAfterTDS: Yup.string().notRequired(),
        // netRisk: Yup.number().required("Net Risk required"),
        // netRiskPayoutAmt: Yup.number().notRequired("Field req"),
        // depositToDeduct: Yup.string().required(),
        // depositAmt: Yup.string().required(),
        // debitAmount: Yup.number().required("Debit Amount required"),
        // netPayout: Yup.string().notRequired(),
        // rmsApprove: Yup.boolean().required("Select a row"),
      })
    ),
  });
  const optionsDf = { resolver: yupResolver(RmsSchema) };
  const {
    control,
    formState,
    handleSubmit,
    register,
    watch,
    reset,
    setValue,
    getValues,
    setError,
    clearErrors,
  } = useForm(optionsDf);
  const { errors } = formState;
  const { fields: rmsField } = useFieldArray({ name: "RmsKey", control });

  useEffect(() => {
    let RmsFilterdata = [...rmsTableData];
    RmsFilterdata.forEach((object) => {
      // delete object["rmsApprove"];
      delete object["apApproved"];
    });
    setRmsField(RmsFilterdata);
    reset({
      RmsKey: RmsFilterdata,
    });
  }, [rmsTableData]);

  const handleType = () => {
    if (typeRef.current.value !== "") {
      setDownloadBtn(true);
      getRMSDetailList("excel", typeRef.current.value);
    } else {
      toast.error("Please select type");
    }
  };
  const downloadEachRecord = (apcode) => {
    if (typeRef.current.value !== "" && apcode != null) {
      setDownloadBtn(true);
      getRMSDetailList("excel", typeRef.current.value, apcode);
    } else {
      toast.error("Please select type");
    }
  };
  const netRiskChange = (e, i, paymentAfterTDS) => {
    if (e.target.value > paymentAfterTDS) {
      e.target.value = 0;
    }
    if (e.target.value.length > 0) {
      let paymentAfterTDS = getValues(`RmsKey.${i}.paymentAfterTDS`);

      let compareValue = paymentAfterTDS - e.target.value;
      if (Math.sign(compareValue) === -1) {
        e.target.style.borderColor = "red";
        setDebitError(true);

        setValue(`RmsKey.${i}.netRiskPayoutAmt`, 0);
        // setError(`RmsKey.${i}.netRisk`, {
        //   type: "custom",
        //   message: "value isnt proper",
        // });
      } else {
        e.target.style.borderColor = "";
        setValue(`RmsKey.${i}.netRiskPayoutAmt`, compareValue.toFixed(2));
        setValue(
          `RmsKey.${i}.netPayout`,
          (compareValue - getValues(`RmsKey.${i}.depositToDeduct`)).toFixed(2)
        );

        // clearErrors(`RmsKey.${i}.netRisk`);
      }
    } else {
      e.target.style.borderColor = "red";
      setValue(`RmsKey.${i}.netRiskPayoutAmt`, 0);
      // setError(`RmsKey.${i}.netRisk`, {
      //   type: "custom",
      //   message: "value isnt proper",
      // });
    }
  };

  const debitAmountChange = (e, i, netRiskPayoutAmt) => {
    if (e.target.value > netRiskPayoutAmt) {
      e.target.value = 0;
    }
    if (e.target.value.length > 0) {
      setValue(`RmsKey.${i}.debitAmount`, e.target.value);
      let compareNetValue =
        getValues(`RmsKey.${i}.netRiskPayoutAmt`) -
        getValues(`RmsKey.${i}.depositToDeduct`);
      setValue(
        `RmsKey.${i}.netPayout`,
        (compareNetValue - e.target.value).toFixed(2)
      );
      e.target.style.borderColor = "";
      clearErrors(`RmsKey.${i}.debitAmount`);
    } else {
      e.target.style.borderColor = "red";
      setValue(`RmsKey.${i}.depositAmt`, 0);
      // setError(`RmsKey.${i}.netRisk`, {
      //   type: "custom",
      //   message: "value isnt proper",
      // });
    }
  };

  const approveInsertBtn = () => {
    let rmsFinalData = { ...getValues() };
    let individualTrue = document.querySelectorAll(".activeData");
    let SubmitArray = [];
    for (let individualdata of individualTrue) {
      if (individualdata.checked && individualdata.disabled != true) {
        const data = rmsFinalData.RmsKey[`${individualdata.id}`];
        // data.debitAmount = Number(data.debitAmount);
        // data.netRisk = Number(data.netRisk);
        // data.netRiskPayoutAmt = Number(data.netRiskPayoutAmt);
        // data.netPayout = Number(data.netPayout);
        // data.lessTDS = Number(data.lessTDS);
        // delete data.apName;
        // delete data.brokerage;
        // delete data.depositAmt;
        // delete data.depositToDeduct;
        // delete data.id;
        // // delete data.lessTDS;
        // delete data.payoutAmt;
        // delete data.sharing;
        // delete data.month;
        // data.rmsApprove = JSON.parse(data.rmsApprove);
        const filteredData = {
          apCode: data?.apCode || "",
          rmsStatus: "Approved",
          rmsRemarks: data?.rmsRemarks || "",
        };
        SubmitArray.push(filteredData);
      }
    }

    if (SubmitArray.length == 0) {
      toast.error("Choose atleast 1 item to Approve");
      return;
    }
    setInsertloadBtn(true);
    insertRMSDetail(SubmitArray);
  };

  const rejectInsertBtn = () => {
    let remarkValue;
    let rmsFinalData = { ...getValues() };
    let individualTrue = document.querySelectorAll(".activeData");
    let SubmitArray = [];
    for (let individualdata of individualTrue) {
      if (individualdata.checked && individualdata.disabled != true) {
        const data = rmsFinalData.RmsKey[`${individualdata.id}`];
        remarkValue = getValues(`RmsKey.${individualdata.id}.rmsRemarks`) || "";
        const filteredData = {
          apCode: data?.apCode || "",
          rmsStatus: "Rejected",
          rmsRemarks: remarkValue || data?.rmsRemarks || "",
        };
        SubmitArray.push(filteredData);
      }
    }

    if (SubmitArray.length == 0) {
      toast.error("Choose atleast 1 item to Reject");
      return;
    }
    if (remarkValue?.length > 0) {
      setRejectloadBtn(true);
      insertRMSDetail(SubmitArray);
    } else {
      toast.error("Please enter rejecting Remarks");
      setRejectloadBtn(false);
    }
  };

  const brokerageHeader = [
    "Select",
    "AP Code",
    "SAP Code",
    "AP Name",
    "Period From",
    "Period To",
    "Module",
    "Pan No",
    "GST No",
    "Actual Gross Brokerage",
    "Gross Brokerage",
    "AP Sharing %",
    "Net Brokerage",
    "GST 18%",
    "Total Invoice",
    "TDS 5%",
    "AP Ledger",
    "AP Risk",
    "Airtel Charges",
    "Deposit to be Adjusted",
    "Deposit Amount",
    "AP AMC",
    "Other Deductions FR",
    "Other Deductions Fin",
    "Final Payout",
    "NSE Registered",
    "BSE Registered",
    "Franchisee Team Approval Status",
    "Franchisee Team Remarks",
    "RMS Team Approval Status",
    "RMS Team Remarks",
    "Finance Team Approval Status",
    "Finance Team Remarks",
    "Banking Team Approval Status",
    "Banking Team Remarks",
  ];

  const singleInputChange = (e) => {
    if (e.target.checked) {
      let AllCheck = [];
      let individualTrue = document.querySelectorAll(".activeData");
      for (let data of individualTrue) {
        AllCheck.push(data.checked);
      }
      if (AllCheck.includes(false)) {
        document.getElementById("select-all-rms").checked = false;
      } else {
        document.getElementById("select-all-rms").checked = true;
      }
    } else {
      document.getElementById("select-all-rms").checked = e.target.checked;
    }
  };
  const selectAllChange = (e) => {
    let individualTrue = document.querySelectorAll(".activeData");
    for (let data of individualTrue) {
      data.checked = e.target.checked;
    }
  };

  return (
    <>
      <Header portal={"RM"} />
      {/* <Sidebar /> */}
      <SingleSignOnSideBar />
      <main id="main-content" className="rms-wrapper">
        <div className="card-box">
          <div className="tableHead">
            <h4 className="rms-title">RMS Table</h4>
          </div>
          {/* <div className="col-md-12 col-sm-12 col-12"> */}
          <div className="form-group">
            {/* <label className="form-label">Type:</label> */}
            <select
              className="report-custom-select product-select"
              // onChange={(e) => handleTypeDropType(e)}
              ref={typeRef}
            >
              {/* <option value="">--Select Type--</option> */}
              <option
                value="brokerage"
                defaultChecked
                style={{ display: "none" }}
              >
                Brokerage
              </option>
              {/* <option value="mtf/las">MTF/LAS</option>
              <option value="amc">AMC</option>
              <option value="slab wise">Slabwise</option> */}
            </select>
          </div>
          {/* </div> */}
          {loader ? (
            <div className="loader-alignment">
              <Loader />
            </div>
          ) : typeRef.current.value !== "" ? (
            <>
              <div className="d-flex justify-content-end">
                <button
                  className="downloadBtnRms1"
                  onClick={() => getClientsRawData()}
                >
                  Raw Download
                </button>
                <button className="downloadBtnRms" onClick={handleType}>
                  {downloadBtnLoader ? (
                    <div className="download-loader">
                      <RoundLoader h={"20"} />
                    </div>
                  ) : (
                    "Download"
                  )}
                </button>
              </div>

              <div className="scroll-table rms-table">
                <table className="table">
                  <thead>
                    {/* brokerage */}

                    {typeRef.current.value === "brokerage" && (
                      <tr>
                        {brokerageHeader.map((item, i) => (
                          <th scope="col" key={i}>
                            {item === "Select" ? (
                              <div className="">
                                <input
                                  className=""
                                  type="checkbox"
                                  id="select-all-rms"
                                  onChange={(e) => selectAllChange(e)}
                                />
                              </div>
                            ) : (
                              <>
                                {item === "Net Risk" ||
                                item === "Debit Amount" ? (
                                  <>
                                    {" "}
                                    {item}
                                    <span className="text-danger"> *</span>
                                  </>
                                ) : (
                                  item
                                )}
                              </>
                            )}
                          </th>
                        ))}
                      </tr>
                    )}
                  </thead>

                  <tbody>
                    {typeRef.current.value === "brokerage" &&
                      rmsField.map((item, i) => (
                        <>
                          <tr key={i}>
                            <td>
                              <div>
                                <input
                                  className={`form-check-input ${
                                    getValues(`RmsKey.${i}.rmsStatus`) ===
                                    "Approved"
                                      ? "inActive"
                                      : "activeData"
                                  }`}
                                  defaultChecked={
                                    getValues(`RmsKey.${i}.rmsStatus`) ===
                                    "Approved"
                                  }
                                  disabled={
                                    getValues(`RmsKey.${i}.rmsStatus`) ===
                                    "Approved"
                                  }
                                  type="checkbox"
                                  id={i}
                                  value={i}
                                  onChange={(e) => singleInputChange(e)}
                                />
                              </div>
                            </td>
                            <td>
                              <input
                                className="plane-input"
                                readOnly
                                {...register(`RmsKey.${i}.apCode`)}
                              />
                            </td>
                            <td>
                              <input
                                className="plane-input"
                                readOnly
                                {...register(`RmsKey.${i}.sapCode`)}
                              />
                            </td>
                            <td>
                              <input
                                className="plane-input"
                                readOnly
                                {...register(`RmsKey.${i}.apName`)}
                              />
                            </td>
                            <td>
                              <input
                                className="plane-input"
                                readOnly
                                value={
                                  getValues(`RmsKey.${i}.periodFrom`)
                                    ? formatDate(
                                        getValues(
                                          `RmsKey.${i}.periodFrom`
                                        )?.split(" ")[0]
                                      )
                                    : " "
                                }
                                // {...register(`ApPayout.${i}.periodFrom`)}
                              />
                            </td>
                            <td>
                              <input
                                className="plane-input"
                                readOnly
                                value={
                                  getValues(`RmsKey.${i}.periodTo`)
                                    ? formatDate(
                                        getValues(
                                          `RmsKey.${i}.periodTo`
                                        )?.split(" ")[0]
                                      )
                                    : " "
                                }
                                // {...register(`ApPayout.${i}.periodTo`)}
                              />
                            </td>
                            <td>
                              <input
                                className="plane-input"
                                readOnly
                                {...register(`RmsKey.${i}.module`)}
                              />
                            </td>
                            <td>
                              <input
                                className="plane-input"
                                readOnly
                                {...register(`RmsKey.${i}.pan`)}
                              />
                            </td>
                            <td>
                              <input
                                className="plane-input"
                                readOnly
                                {...register(`RmsKey.${i}.gstNo`)}
                              />
                            </td>
                            <td>
                              <input
                                className="plane-input"
                                readOnly
                                {...register(
                                  `RmsKey.${i}.actualGrossBrokerage`
                                )}
                              />
                            </td>
                            <td>
                              <input
                                className="plane-input"
                                readOnly
                                {...register(`RmsKey.${i}.grossBrokerage`)}
                              />
                            </td>
                            <td>
                              <input
                                className="plane-input"
                                readOnly
                                {...register(`RmsKey.${i}.apSharing`)}
                              />
                            </td>
                            <td>
                              <input
                                className="plane-input"
                                readOnly
                                {...register(`RmsKey.${i}.netBrokerage`)}
                              />
                            </td>
                            <td>
                              <input
                                className="plane-input"
                                readOnly
                                {...register(`RmsKey.${i}.gst18Perc`)}
                              />
                            </td>
                            <td>
                              <input
                                className="plane-input"
                                readOnly
                                {...register(`RmsKey.${i}.totalInvoice`)}
                              />
                            </td>
                            <td>
                              <input
                                className="plane-input"
                                readOnly
                                {...register(`RmsKey.${i}.tds5Perc`)}
                              />
                            </td>
                            <td>
                              <input
                                className="plane-input"
                                readOnly
                                {...register(`RmsKey.${i}.apLedger`)}
                              />
                            </td>
                            <td>
                              <input
                                className="plane-input"
                                readOnly
                                {...register(`RmsKey.${i}.apRisk`)}
                              />
                            </td>
                            <td>
                              <input
                                className="plane-input"
                                readOnly
                                {...register(`RmsKey.${i}.airtelCharges`)}
                              />
                            </td>
                            <td>
                              <input
                                className="plane-input"
                                readOnly
                                {...register(`RmsKey.${i}.depositToBeAdjusted`)}
                              />
                            </td>
                            <td>
                              <input
                                className="plane-input"
                                readOnly
                                {...register(`RmsKey.${i}.depositAmt`)}
                              />
                            </td>
                            <td>
                              <input
                                className="plane-input"
                                readOnly
                                {...register(`RmsKey.${i}.apAMC`)}
                              />
                            </td>
                            <td>
                              <input
                                className="plane-input"
                                readOnly
                                {...register(`RmsKey.${i}.otherDeductionFR`)}
                              />
                            </td>
                            <td>
                              <input
                                className="plane-input"
                                readOnly
                                {...register(`RmsKey.${i}.otherDeductionFin`)}
                              />
                            </td>
                            <td>
                              <input
                                className="plane-input"
                                readOnly
                                {...register(`RmsKey.${i}.finalPayout`)}
                              />
                            </td>
                            <td>
                              <input
                                className="plane-input"
                                readOnly
                                {...register(`RmsKey.${i}.nseRegistered`)}
                              />
                            </td>
                            <td>
                              <input
                                className="plane-input"
                                readOnly
                                {...register(`RmsKey.${i}.bseRegistered`)}
                              />
                            </td>
                            <td>
                              <input
                                className="plane-input"
                                readOnly
                                {...register(`RmsKey.${i}.franchiseeStatus`)}
                              />
                            </td>
                            <td>
                              <input
                                className="plane-input"
                                readOnly
                                {...register(`RmsKey.${i}.franchiseeRemarks`)}
                              />
                            </td>
                            <td>
                              <input
                                className="plane-input"
                                readOnly
                                {...register(`RmsKey.${i}.rmsStatus`)}
                              />
                            </td>
                            <td>
                              <input
                                className="onChange-field"
                                defaultValue={getValues(
                                  `RmsKey.${i}.rmsRemarks`
                                )}
                                {...register(`RmsKey.${i}.rmsRemarks`)}
                                onInput={(e) => {
                                  e.target.value = e.target.value.replace(
                                    /^\s+/,
                                    ""
                                  );
                                }}
                                disabled={
                                  getValues(`RmsKey.${i}.rmsStatus`) ===
                                  "Approved"
                                }
                              />
                            </td>
                            <td>
                              <input
                                className="plane-input"
                                readOnly
                                {...register(`RmsKey.${i}.financeStatus`)}
                              />
                            </td>
                            <td>
                              <input
                                className="plane-input"
                                readOnly
                                {...register(`RmsKey.${i}.financeRemarks`)}
                              />
                            </td>
                            <td>
                              <input
                                className="plane-input"
                                readOnly
                                {...register(`RmsKey.${i}.bankingStatus`)}
                              />
                            </td>
                            <td>
                              <input
                                className="plane-input"
                                readOnly
                                {...register(`RmsKey.${i}.bankingRemarks`)}
                              />
                            </td>
                          </tr>
                        </>
                      ))}
                  </tbody>
                </table>
              </div>
              <p className="pt-5" style={{ fontSize: "1.5rem" }}>
                Total No Of Records : {rmsField.length}
              </p>
              <div className="wrap-buttons">
                <div className="approve-reject-btn">
                  <button
                    value="grid"
                    className="approve-btn"
                    onClick={approveInsertBtn}
                  >
                    {insertBtnLoader ? (
                      <div className="download-loader">
                        <RoundLoader h={"10"} />
                      </div>
                    ) : (
                      "Approve"
                    )}
                  </button>
                </div>

                <div className="approve-reject-btn">
                  <button
                    value="grid"
                    className="reject-btn"
                    onClick={rejectInsertBtn}
                  >
                    {rejectBtnLoader ? (
                      <div className="download-loader">
                        <RoundLoader h={"10"} />
                      </div>
                    ) : (
                      "Reject"
                    )}
                  </button>
                </div>
              </div>
            </>
          ) : (
            ""
          )}
        </div>
      </main>
    </>
  );
}

export default RmsPayout;
